export default "__VITE_ASSET__KnC$NHYo__"